import http from "../../config/BaseUrl";

const endpoint = "automation/roi-dashboard";

export const fetchRoiDashboard = (params) => http.get(endpoint, { params });

export const fetchRoiDefinitions = () => http.get(`${endpoint}/definitions`);

export const fetchRoiDrillDown = (metric, params) =>
  http.get(`${endpoint}/drill-down/${encodeURIComponent(metric)}`, { params });

const normaliseReportUrl = (url) => {
  if (typeof url !== "string") return "";

  return url.replace(/^\/api\/v1\//, "").replace(/^api\/v1\//, "");
};

const authenticatedReportRequest = (url) => http.get(normaliseReportUrl(url), { responseType: "blob" });

export const previewRoiReport = (url) => authenticatedReportRequest(url);

export const downloadRoiReport = (url) => authenticatedReportRequest(url);
